import type {ProductUpdate} from './types';

export const PRODUCT_UPDATES: ProductUpdate[] = [
    {
        title: 'Shared inbox',
        description: 'Centralize customer emails and collaborate on replies',
        learnMoreLink:
            'https://support.nutshell.com/en/articles/14464281-shared-email-inbox-in-nutshell',
        illustration: 'shared-email-inbox-thumbnail',
    },
    {
        title: 'Scheduler report',
        description: 'Analyze booking trends and statistics for your scheduler meetings.',
        learnMoreLink: 'https://support.nutshell.com/en/articles/13908902-scheduler-report',
        illustration: 'scheduler-report-thumbnail',
    },
    {
        title: 'AI follow-up tasks',
        description:
            'Automatically capture action items from meeting conversations and turn them into tangible tasks in Nutshell.',
        learnMoreLink:
            'https://support.nutshell.com/en/articles/14061539-automatically-create-follow-up-tasks-from-your-calls',
        illustration: 'ai-follow-up-tasks-thumbnail',
    },
];
